<div #popupMap class="ui modal">
  <div class="header">{{popupHeader}}</div>
  <div class="content">
    <div #mapElement id="map" class="openlayers-map"></div>
  </div>
</div>
 

